export enum JustupColors {
  VERT = "rgb(5,255,173)",
  POMME = "rgb(206,248,130)",
  BLEU = "rgb(44,67,238)",
  VIOLET = "rgb(155,57,227)",
  ROSE = "rgb(255,134,147)",
  NOIR = "rgb(30,37,45)",
  JAUNE = "rgb(255,242,10)",
  SABLE = "rgb(234,234,226)",
  CIEL = "rgb(198,241,250)",
  BLEU_GRIS = "rgb(148,172,221)",
  VERT_OK = "rgb(17,200,95)",
  ROUGE_NOK = "rgb(223,0,61)",
  ORANGE = "rgb(255,101,67)",
  MILKA = "rgb(154,134,229)",
  BLEU_VERT = "rgb(178,230,240)",
  BLEU_CLAIR = "rgb(70,171,241)",
  GRIS = "rgb(204,204,204)",
  ROUGE_CLAIR = "rgb(200,45,85)",
}

export enum JustupColorsHEX {
  NOIR = "#1D252C",
}
